import { object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  allergyId: string().required(),
})

export const url = ({ allergyId }) => `/v1/allergies/${allergyId}`
